import { FileProvider } from './context/FileContext';
import MainLayout from './components/layout/MainLayout';
import { useEffect } from 'react';
import ReactGA from 'react-ga4';
import { APP_URLS } from './constants/analytics';
import { trackSessionDuration } from './utils/analyticsEvents';

function App() {
  useEffect(() => {
    // Always send the same base URL to GA to protect privacy
    // even if the browser address bar contains repo/file names
    ReactGA.send({
      hitType: 'pageview',
      page: '/', // Hardcoded path to hide deep URL info from GA
      location: window.location.origin + '/', // Dynamically get origin (localhost or prod)
      title: APP_URLS.title
    });

    // Track session duration
    const sessionStart = Date.now();
    const handleBeforeUnload = () => {
      const durationSeconds = (Date.now() - sessionStart) / 1000;
      trackSessionDuration(durationSeconds);
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => window.removeEventListener('beforeunload', handleBeforeUnload);
  }, []);

  return (
    <FileProvider>
      <MainLayout />
    </FileProvider>
  );
}

export default App;
